import AllEvent from "./all-events-section";
import MyEvent from "./my-events-section";

export default {
    AllEvent,
    MyEvent,
}
